import type { ReactNode } from "react";
import { cx } from "../utils/cx";

/** A Latin token (code, URL, Sheba, ID) inside Persian text: isolated LTR run with Latin digits. */
export const Latin = ({ children, className, tabular }: { children: ReactNode; className?: string; tabular?: boolean }) => (
    <bdi dir="ltr" className={cx(tabular ? "latin-digits-tabular" : "latin-digits", className)}>
        {children}
    </bdi>
);

/**
 * Free text (server messages, notifications, help) where Latin words, codes, masked domains and
 * `#123` references must keep Latin digits while plain Persian numbers stay Persian.
 */
export const LatinRuns = ({ text }: { text: string }) => (
    <>
        {text.split(/((?:[A-Za-z#][\w.#:/@{}*-]*[\w}*])|(?:[A-Za-z]))/).map((part, i) =>
            i % 2 === 1 ? (
                <bdi key={i} dir="ltr" className="latin-digits">
                    {part}
                </bdi>
            ) : (
                part
            ),
        )}
    </>
);
